import { render, staticRenderFns } from "./CalendarDataWorkspace.vue?vue&type=template&id=50a787c6&scoped=true"
import script from "./CalendarDataWorkspace.vue?vue&type=script&lang=js"
export * from "./CalendarDataWorkspace.vue?vue&type=script&lang=js"
import style0 from "./CalendarDataWorkspace.vue?vue&type=style&index=0&id=50a787c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50a787c6",
  null
  
)

export default component.exports